import { CalculationResult } from "@/lib/api";

const API_URL = process.env.NEXT_PUBLIC_API_URL || "http://localhost:8000";

export async function exportResultsToXlsx(
  results: CalculationResult[],
  portalName: string
) {
  const token = localStorage.getItem("hitmark_token") || "";
  const res = await fetch(`${API_URL}/api/export`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({
      results,
      portal_name: portalName,
    }),
  });

  if (!res.ok) throw new Error("Failed to generate report");

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `Raport_${portalName}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
}
